import React, {useContext} from 'react';
import Welcome from './Welcome';
import DashInfo from './DashInfo';

export const Dashboard = () => {
    return (
    <>
        <Welcome />
        <DashInfo/>
    </>)
}

export default Dashboard;